import { SprayCan, ShieldCheck, CalendarCheck } from "lucide-react";

export const TrustBar = () => {
  const highlights = [
    {
      icon: <SprayCan className="h-6 w-6 text-primary" />,
      title: "Meticulous",
      description: "Thorough work. Thoughtful details."
    },
    {
      icon: <ShieldCheck className="h-6 w-6 text-primary" />,
      title: "Trusted",
      description: "Reliable vetted pros."
    },
    {
      icon: <CalendarCheck className="h-6 w-6 text-primary" />,
      title: "Seamless",
      description: "Easy online booking & payments."
    }
  ];

  return (
    <section className="border-y bg-muted/30 py-8">
      <div className="container">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-4">
          {highlights.map((item, i) => (
            <div key={i} className="flex items-center gap-4 md:justify-center">
              <div className="flex h-12 w-12 items-center justify-center rounded-full bg-primary/10">
                {item.icon}
              </div>
              <div>
                <h2 className="font-bold text-lg">{item.title}</h2>
                <p className="text-sm text-muted-foreground">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
